__turbopack_context__.v({
  "illust": "DefaultRightSide-module-scss-module__I956Qa__illust",
});
